import { parseSectionSettings } from 'legacy/lut/features/partner360/configuration'
import type { IClientSectionSettings } from 'legacy/lut/features/partner360/sectionSettings/models/iSectionSettingsState'
import { fetchPartner360Configuration } from 'legacy/lut/services/partner360/configuration/fetchPartner360Configuration'
import { useEffect, useState } from 'react'

export const usePartnerPlanningInfo = ({
  pid,
  currentFiscalYear,
}: {
  pid: string
  currentFiscalYear: number
}) => {
  const [partnerFlags, setPartnerFlags] = useState('')
  const [sectionSettings, setSectionSettings] = useState<Partial<IClientSectionSettings>>({})
  const [isPartnerPlanningInfoLoaded, setIsPartnerPlanningInfoLoaded] = useState(false)

  useEffect(() => {
    let isActual = true

    setPartnerFlags('')
    setSectionSettings({})
    setIsPartnerPlanningInfoLoaded(false)

    if (!pid || !currentFiscalYear) {
      setIsPartnerPlanningInfoLoaded(true)

      return () => {
        isActual = false
      }
    }

    const fetchPartnerPlanningInfo = async () => {
      try {
        const partnerInfo = await fetchPartner360Configuration({
          partnerId: pid,
          fYear: currentFiscalYear,
        })

        if (!isActual) {
          return
        }

        setPartnerFlags(partnerInfo.PartnerFlags || '')
        setSectionSettings(
          parseSectionSettings(
            partnerInfo.SectionSettings || null
          ) as Partial<IClientSectionSettings>
        )
      } catch {
        if (isActual) {
          setPartnerFlags('')
          setSectionSettings({})
        }
      } finally {
        if (isActual) {
          setIsPartnerPlanningInfoLoaded(true)
        }
      }
    }

    void fetchPartnerPlanningInfo()

    return () => {
      isActual = false
    }
  }, [currentFiscalYear, pid])

  return {
    partnerFlags,
    sectionSettings,
    isPartnerPlanningInfoLoaded,
  }
}
